module.exports = __webpack_public_path__ + "media/images/proof_links/foursquare-d07029111e19498d226f086287ca74f1.svg";